import { ArrowUpRight, ArrowDownRight, Minus, Pencil, Trash2, History } from "lucide-react";
import { Button } from "@/components/ui/button";

const DOMAINS = [
  ["SAHSIAH", "Sahsiah"], ["BAHASA", "Bahasa"], ["FIZIKAL", "Fizikal"],
  ["DERIA", "Deria"], ["LOGIK", "Logik"], ["KREATIVITI", "Kreativiti"],
];

const Delta = ({ value }) => {
  if (value === null || value === undefined) return null;
  const v = Math.round(value * 10) / 10;
  if (v > 0) return <span className="inline-flex items-center text-xs font-semibold text-emerald-700"><ArrowUpRight className="w-3.5 h-3.5" />+{v}%</span>;
  if (v < 0) return <span className="inline-flex items-center text-xs font-semibold text-red-600"><ArrowDownRight className="w-3.5 h-3.5" />{v}%</span>;
  return <span className="inline-flex items-center text-xs font-semibold text-gray-500"><Minus className="w-3.5 h-3.5" />0%</span>;
};

// Senarai komen guru mengikut penggal + perbandingan kemajuan
export default function CommentHistory({ history, currentProgress, isStaff, onEdit, onDelete }) {
  if (!history?.length) {
    return (
      <div data-testid="comment-history-empty" className="text-center py-8 text-sm text-gray-500">
        <History className="w-8 h-8 mx-auto mb-2 text-gray-300" />
        Belum ada komen disimpan. Komen bagi setiap penggal akan direkodkan di sini.
      </div>
    );
  }
  // history: terbaru dahulu -> beza dengan penggal sebelumnya (item seterusnya)
  return (
    <div className="space-y-3" data-testid="comment-history-list">
      {currentProgress && (
        <div className="text-xs text-gray-600 bg-gray-50 rounded-lg px-3 py-2">
          Kemajuan terkini: <b className="text-purple-800">{currentProgress.percentage}%</b> ({currentProgress.achieved}/{currentProgress.total} item)
        </div>
      )}
      {history.map((h, idx) => {
        const prev = history[idx + 1];
        const pct = h.progress_snapshot?.percentage;
        const prevPct = prev?.progress_snapshot?.percentage;
        const delta = pct !== undefined && prevPct !== undefined ? pct - prevPct : null;
        return (
          <div key={h.id || h.term_key} data-testid={`history-item-${h.term_key}`} className="rounded-xl border border-gray-200 bg-white p-3">
            <div className="flex items-start justify-between gap-2">
              <div>
                <p className="text-sm font-bold text-purple-800">{h.term_label} <span className="font-normal text-xs text-gray-500">({h.term_months})</span></p>
                <p className="text-xs text-gray-500">
                  {h.teacher_name || "-"}{h.updated_at ? ` · ${new Date(h.updated_at).toLocaleDateString("ms-MY")}` : ""}
                </p>
              </div>
              <div className="text-right shrink-0">
                {pct !== undefined && <p className="text-lg font-black text-gray-900 leading-tight">{pct}%</p>}
                <Delta value={delta} />
              </div>
            </div>
            {h.progress_snapshot?.domains && (
              <div className="flex flex-wrap gap-1.5 mt-2">
                {DOMAINS.filter(([c]) => h.progress_snapshot.domains[c]?.total).map(([c, label]) => {
                  const cur = h.progress_snapshot.domains[c].percentage;
                  const p = prev?.progress_snapshot?.domains?.[c];
                  const d = p?.total ? cur - p.percentage : null;
                  return (
                    <span key={c} className="inline-flex items-center gap-1 rounded-md bg-purple-50 text-purple-800 px-2 py-0.5 text-[11px] font-medium">
                      {label} {cur}%{d !== null && d !== 0 && <span className={d > 0 ? "text-emerald-700" : "text-red-600"}>({d > 0 ? "+" : ""}{d})</span>}
                    </span>
                  );
                })}
              </div>
            )}
            <p className="text-sm text-gray-700 whitespace-pre-line mt-2">{h.comment || <i className="text-gray-400">Tiada komen</i>}</p>
            {isStaff && (
              <div className="flex justify-end gap-1 mt-2">
                <Button type="button" size="sm" variant="ghost" data-testid={`history-edit-${h.term_key}`} onClick={() => onEdit(h.term_key)} className="h-8 text-purple-700 hover:bg-purple-50">
                  <Pencil className="w-3.5 h-3.5 mr-1" /> Sunting
                </Button>
                <Button type="button" size="sm" variant="ghost" data-testid={`history-delete-${h.term_key}`} onClick={() => onDelete(h.term_key)} className="h-8 text-red-600 hover:bg-red-50">
                  <Trash2 className="w-3.5 h-3.5 mr-1" /> Padam
                </Button>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
